export function get2x2TeamPlayerNumber(movesCount: number): 1 | 2 {
  return ((Math.floor(movesCount / 2) % 2) + 1) as 1 | 2;
}
